import { ReactNode, ReactPortal, useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'

const createRootElement = (id: string): HTMLDivElement => {
  const rootContainer = document.createElement('div')
  rootContainer.setAttribute('id', id)
  rootContainer.setAttribute('data-testid', id)
  return rootContainer
}

const checkExistingParent = (id: string) => document.querySelector(`#${id}`)

export const usePortal = (id: string) => {
  const existing = checkExistingParent(id)
  const wrapper = useMemo(() => existing || createRootElement(id), [id])

  useEffect(() => {
    document.body.appendChild(wrapper)

    return () => {
      document.body.removeChild(wrapper)
    }
  }, [wrapper])

  return {
    render: (children: ReactNode): ReactPortal =>
      createPortal(children, wrapper),
  }
}
